import { HeaderComponent } from "./index";
import { IonCardContent, IonContent, IonIcon, IonPage } from "@ionic/react";
import React from "react";
import {
    closeOutline,
    ellipsisHorizontalCircle,
    ellipsisHorizontalOutline,
} from "ionicons/icons";
import { useTranslation } from "react-i18next";
import "./NewFeaturesContent.css";
import { getLanguageCode } from "../utils/localeUtils";
import newFeaturesImage from "../assets/images/new-features/scorza-1.3-edit-match.png";
import { ScorzaCard } from "./stats/ScorzaCard";

// test function so easily show different variants
// const isIos = () => {
//     return false;
// };

export const NewFeatureContent = (dismiss: () => void) => {
    const { t } = useTranslation();

    const language = getLanguageCode();

    return (
        <IonPage className="new-features-modal">
            <HeaderComponent
                title={t("help.WhatsNewModal.title")}
                onClickEndButton={() => {
                    dismiss();
                }}
                endBtnIconName={closeOutline}
                titleTestId="new-feature-title"
                endBtnTestId="new-feature-header-close"
            />
            <IonContent className="new-features">
                <ScorzaCard title="v1.3 - Edit Match Details">
                    <IonCardContent>
                        <img
                            src={newFeaturesImage}
                            style={{
                                border: "1px solid grey",
                                borderRadius: "5px",
                                display: "block",
                                margin: "0 auto",
                                marginBottom: "10px",
                            }}
                        ></img>

                            <p>
                                Set the <b>score, team names</b> and{" "}
                                <b>colours</b>
                            </p>
                            <p>Record the Venue and Competition</p>
                            <p>
                                Access via{" "}
                                <IonIcon
                                    color="primary"
                                    icon={ellipsisHorizontalOutline}
                                ></IonIcon>{" "}
                                at the top right of the match page.
                            </p>

                    </IonCardContent>
                </ScorzaCard>
                <ScorzaCard title="Scorza 1.0">
                    <IonCardContent>
                        <p>
                            Your complete football performance tracking
                            solution:
                        </p>
                        <ul>
                            <li>
                                Connect any compatible smartwatch to our
                                performance vest
                            </li>
                            <li>
                                Track speed, distance, heart rate and
                                football-specific metrics
                            </li>
                            <li>Review detailed post-match analytics</li>
                            <li>Monitor your progress over time</li>
                            <li>Compare performances across sessions</li>
                        </ul>
                    </IonCardContent>
                </ScorzaCard>
            </IonContent>
        </IonPage>
    );
};
